import styled, { css } from 'react-emotion';

export const Panel = styled.div`
	display: flex;
	margin: 1rem 0;
	max-width: 100%;
	font-size: 1rem;
	width: 100%;
	flex: 1 0 100%;
	font-family: 'Barlow', sans-serif;

	@media (max-width: 720px) {
		display: none;
	}
`;

export const Label = styled.div`
	flex: 1 0 auto;
	font-weight: 600;
	padding-right: 0.5rem;
`;

export const Marquee = styled.div`
	contain: strict;
	flex: 10 1 80%;
	overflow: hidden;
	white-space: nowrap;

	span {
		display: inline-block;
		will-change: transform;
		white-space: nowrap;
	}
`;

export const link = css`
	font-family: 'Barlow', sans-serif;
	padding: 0 0.25rem;
`;
